import { goalTypeLabel } from "@/shared/domain/agents";
import {
  FileText,
  Flag,
  type LucideIcon,
  Tags,
} from "@/shared/foundation/icons";

import { type GoalKind } from "../agentFormSchema";

/** The kinds of goal on offer, in the order the picker shows them. */
export const GOAL_KINDS: readonly GoalKind[] = [
  "dataset_summary",
  "dataset_triage",
  "create_events",
];

/**
 * What a goal added from the button is until its own picker says otherwise:
 * the one that needs nothing filled in to be valid.
 */
export const DEFAULT_GOAL_KIND: GoalKind = "dataset_summary";

/** How a kind of goal is named wherever one is shown. */
export interface GoalKindCopy {
  label: string;
  /** One line on what a goal of this kind does. */
  description: string;
  icon: LucideIcon;
}

/**
 * The form's picker and the agent's own page both name goals from this, so a
 * kind reads the same while it is written and once it is saved. The label is
 * {@link goalTypeLabel}'s, which also names goals the editor cannot edit and a
 * thread's goal chips.
 */
export const GOAL_KIND_COPY: Record<GoalKind, GoalKindCopy> = {
  dataset_summary: {
    label: goalTypeLabel("dataset_summary"),
    description: "Write up what the dataset contains",
    icon: FileText,
  },
  dataset_triage: {
    label: goalTypeLabel("dataset_triage"),
    description: "Tag the dataset from a vocabulary you set",
    icon: Tags,
  },
  create_events: {
    label: goalTypeLabel("create_events"),
    description: "Mark moments in the dataset from a vocabulary you set",
    icon: Flag,
  },
};
